import React, { Suspense, lazy } from 'react'
import { cn } from '../../lib/utils'

interface LazyComponentProps {
  children: React.ReactNode
  fallback?: React.ReactNode
  className?: string
}

// Loading skeleton component
const LoadingSkeleton: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn('animate-pulse bg-gray-200 rounded', className)} />
)

// Generic lazy component wrapper
export const LazyComponent: React.FC<LazyComponentProps> = ({
  children,
  fallback = <LoadingSkeleton className="h-32 w-full" />,
  className
}) => (
  <div className={className}>
    <Suspense fallback={fallback}>
      {children}
    </Suspense>
  </div>
)

// Lazy load heavy components
export const LazyHeroCarousel = lazy(() => 
  import('../sections/HeroCarousel').then(module => ({ default: module.HeroCarousel }))
)

export const LazyServicesCarousel = lazy(() => 
  import('../sections/ServicesCarousel').then(module => ({ default: module.ServicesCarousel }))
)

export const LazyContactForm = lazy(() => 
  import('../sections/ContactForm').then(module => ({ default: module.ContactForm }))
)

export const LazyLocationAccordion = lazy(() => 
  import('../sections/LocationAccordion').then(module => ({ default: module.default }))
)